import { lazy } from "common/load/componentUtils";

import { CloseProp, useDrawer } from "client/common/hooks/stackables";

import type { PaymentCreateDrawerProps } from "../components/PaymentCreateDrawer";

const PaymentCreateDrawer = lazy(() => import("../components/PaymentCreateDrawer"));

export const usePaymentCreateDrawer = () => {
  const { open } = useDrawer();
  return {
    open: (props: PaymentCreateDrawerProps & CloseProp) => open(PaymentCreateDrawer, props),
  };
};
